// base
import { createSlice } from '@reduxjs/toolkit';
// actions
import { SECL_SLICE_NAME } from '../actions/secl.action';
// thunks
import {
  createSecl,
  getSeclHistoryList,
  getSeclHistoryListVendor,
  getSeclList
} from '../thunks/secl.thunk';

// initialState
const initialState = {
  seclList: [],
  history: [],
  historyTotalMap: undefined,
  historyVendor: [],
  historyVendorTotalMap: undefined,
  seclInfo: undefined
};

// createSlice
const seclSlice = createSlice({
  name: SECL_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeclHistoryList.fulfilled, (state, action) => {
      const res = action.payload;
      state.history = res?.resultList || [];
      state.historyTotalMap = res?.totalMap;
    });

    builder.addCase(getSeclHistoryListVendor.fulfilled, (state, action) => {
      const res = action.payload;
      state.historyVendor = res?.resultList || [];
      state.historyVendorTotalMap = res?.totalMap;
    });

    builder.addCase(getSeclList.fulfilled, (state, action) => {
      const res = action.payload;
      state.seclList = res?.resultList || [];
    });

    builder.addCase(createSecl.fulfilled, (state, action) => {
      const res = action.payload;
      state.seclInfo = res?.resultObject;
    });
  }
});

export const secl = seclSlice.name;
export const seclReducer = seclSlice.reducer;
export const seclActions = seclSlice.actions;
export default seclSlice.reducer;
